import React,{useState, useEffect} from 'react';
import styles from './index.module.scss';

import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import {Slogon} from '../../slogon';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const  ImgTxtDetail = (props)=>{
    const [url, setUrl] = useState('');
    
    useEffect(() => {
        // 从URL参数中获取图片链接
        const urlParams = new URLSearchParams(window.location.search);
        const imageUrl = urlParams.get('url');
        if (imageUrl) {
            setUrl(decodeURIComponent(imageUrl));
        }
    }, []);

    console.log('ImgTxtDetail');
    console.log(props);
    console.log(url);
    console.log('ImgTxtDetail');
    
    return <div className={styles.container}>
        <div className={styles.content}>
            <img className={styles.title1Img} src={url} referrerPolicy="no-referrer" />
        </div>
    </div>
};
